var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCultural(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffa600"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#gradient)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 l-3,5 l-4,2 l-2,3 l4,4 l-2,3 l3,3 l-1,4 l5,2 l2,3 l4,-1 l3,3 l4,-2 l2,-4 l-3,-5 l1,-3 l-2,-2 l3,-3 l-3,-3 l-5,1 l-1,-3 l-5,-3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,15 c0,-5 8,-5 8,0 v5 h-8 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 15,
    rx: 4,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 20,
    x2: 41,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 25,
    width: 12,
    height: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,25 v15 M33,30 h2 M33,35 h2 M39,30 h2 M39,35 h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,22 c0,0 4,-3 12,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 20,
    x2: 25,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 19,
    x2: 29,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 20,
    x2: 33,
    y2: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultural);
export default __webpack_public_path__ + "static/media/cultural.770a388873cfe6e280e12f67b92f47f5.svg";
export { ForwardRef as ReactComponent };